import React, { useEffect } from 'react';
import { logger as log } from '@common/logger';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const sendOTPContext = React.createContext({});
export let sendOTPMachine: any;

const MODULE_NAME = 'machines.pageContent';

export const useSMSendOTP = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  sendOTPMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(sendOTPMachine);

  return {
    sendOTPMachine,
    sendOTPState: state,
    sendOTPSend: send,
  };
};
